import {
    START_FETCH_ACCESS_ROLES,
    ACCESS_ROLES_FETCH_SUCCESS,
    ACCESS_ROLES_FETCH_FAILED,
} from "./types";
import axios from "axios";
import { BaseUrl } from "./api";

export const fetchRoles = (token) => {
    return async (dispatch) => {
        dispatch({
            type: START_FETCH_ACCESS_ROLES,
        });
        try {
            const res = await axios.get(`${BaseUrl}/access_roles`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    dataType: "json",
                    Authorization: `Bearer ${token}`,
                },
            });
            // console.log('response',res);
            if (res.statusText === "OK") {
                // console.log("status ok!!!", res.data);
                dispatch({
                    type: ACCESS_ROLES_FETCH_SUCCESS,
                    payload: res.data,
                });
            } else {
                dispatch({
                    type: ACCESS_ROLES_FETCH_FAILED,
                    payload: "fetching roles failed",
                });
            }
        } catch (error) {
            // console.log(error);
            dispatch({
                type: ACCESS_ROLES_FETCH_FAILED,
                payload: error.message,
            });
        }
    };
};
